import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Scelta delle categorie da mostrare nei filtri del portfolio. */
export const CategoryPicker = ({ value = [], onChange, id }) => {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/admin/categories").then((r) => setCats(r.data.items)); }, []);
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  return (
    <div className="space-y-2" data-testid={id}>
      <p className="text-xs text-slate-500">Se non selezioni nulla vengono mostrate tutte le categorie visibili. Le categorie nascoste (Impostazioni → Categorie) non compaiono mai sul sito.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {cats.map((c, k) => (
          <label key={c.id} className={`flex items-center gap-2 text-sm border border-line rounded px-3 py-2 cursor-pointer ${c.visible ? "" : "opacity-50"}`}>
            <input type="checkbox" checked={value.includes(c.event_type)} onChange={() => toggle(c.event_type)} data-testid={`${id}-${c.event_type}`} />
            {c.title}{!c.visible && <span className="text-[11px] text-slate-500">(nascosta)</span>}
          </label>
        ))}
      </div>
    </div>
  );
};
